module.exports = __webpack_public_path__ + "img/cred.46768cbf.svg";